/*
  gfBar WebMCP tool for AI agents (2026-10-25).

  Shopify's storefront script already registers the shop-wide tools (search,
  cart, checkout, policies). Its add_to_cart takes a variant and a quantity but
  no selling plan, so an agent could buy a carton but could not put a visitor
  into gfBar Klub. This file adds that one missing tool: join_gfbar_club.

  It drives the real buy box: it picks the flavour, ticks the Klub option and
  submits the same form a person would, so the cart drawer, the counter and the
  theme's own error handling behave exactly as after a click. The result is
  confirmed against /cart.js, never assumed.

  Registered only where a buy box with a Klub option exists (homepage, product
  pages). WebMCP is still in origin trial; in browsers without it this file
  does nothing.
*/
(function () {
  'use strict';

  var mc = document.modelContext || navigator.modelContext;
  if (!mc || typeof mc.registerTool !== 'function') return;
  if (window.__gfWebmcp) return;
  window.__gfWebmcp = true;

  function clean(s) {
    return String(s || '').replace(/\s+/g, ' ').trim();
  }

  function offer() {
    return document.getElementById('gf-offer');
  }

  // Flavours in the buy box that have a Klub option, keyed by the swatch name
  // as shown on the page (ORIGINAL, COCOA, VARIETY ...).
  function clubOptions() {
    var root = offer();
    var out = {};
    if (!root) return out;
    var swatches = root.querySelectorAll('.gf-swatch');
    for (var i = 0; i < swatches.length; i++) {
      var label = swatches[i].querySelector('.gf-swatch__name');
      var name = clean(label && label.textContent).toUpperCase();
      var radio = document.getElementById(swatches[i].getAttribute('for'));
      if (!name || !radio) continue;
      var variant = root.querySelector('.gf-offer__variant[data-flavour="' + radio.value + '"]');
      var form = variant && variant.querySelector('form.gf-offer__form');
      // The one-time option posts selling_plan="" — the Klub option is the other one.
      var plan = form && form.querySelector('input[name="selling_plan"]:not([value=""])');
      if (form && plan) out[name] = { radio: radio, form: form, plan: plan };
    }
    return out;
  }

  // Show the chosen flavour with Klub ticked, as a visitor would see it.
  // On a product page a flavour change opens that product's page, so there the
  // radios are only ticked, without the change event that navigates.
  function select(opt) {
    var root = offer();
    var pdp = root.classList.contains('gf-offer--pdp');
    var group = opt.radio.closest('.gf-offer__flavours');
    var tab = group && root.querySelector('.gf-viewtab__radio[value="' + group.getAttribute('data-group') + '"]');
    if (tab && !tab.checked) {
      tab.checked = true;
      if (!pdp) tab.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (!opt.radio.checked) {
      opt.radio.checked = true;
      if (!pdp) opt.radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
    var shot = root.querySelector('.gf-gallery > .gf-offer__radio');
    if (shot) shot.checked = true;
    opt.plan.checked = true;
    opt.plan.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function cartUrl() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (r || '/') + 'cart.js';
  }

  // Cartons of this variant already in the cart on this selling plan.
  function clubQty(variantId, planId) {
    return fetch(cartUrl(), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var qty = 0;
        (cart.items || []).forEach(function (item) {
          var sp = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
          if (String(item.variant_id) === String(variantId) && sp && String(sp.id) === String(planId)) {
            qty += item.quantity;
          }
        });
        return qty;
      });
  }

  function waitForMore(variantId, planId, before) {
    var deadline = Date.now() + 8000;
    return new Promise(function (resolve) {
      (function tick() {
        clubQty(variantId, planId).then(function (qty) {
          if (qty > before) return resolve(qty);
          if (Date.now() > deadline) return resolve(null);
          setTimeout(tick, 500);
        }, function () {
          if (Date.now() > deadline) return resolve(null);
          setTimeout(tick, 500);
        });
      })();
    });
  }

  var names = Object.keys(clubOptions());
  if (!names.length) return;

  var tool = {
    name: 'join_gfbar_club',
    description:
      'Add one carton (12 boxes, 24 bars) of the chosen gfBar flavour or mix to the cart as a gfBar Klub ' +
      'membership: a recurring delivery with every monthly production batch, at the same price as a ' +
      'one-time purchase, with no commitment; the customer can change or cancel it any time in their ' +
      'account. Use only when the visitor asks for the subscription, gfBar Klub or a regular monthly ' +
      'delivery. For a one-time purchase use add_to_cart instead. This only adds to the cart; the ' +
      'visitor still reviews and pays at checkout.',
    inputSchema: {
      type: 'object',
      properties: {
        flavour: {
          type: 'string',
          enum: names,
          description: 'The flavour or mix, exactly as named on the page.'
        }
      },
      required: ['flavour']
    },
    annotations: { readOnlyHint: false },
    execute: async function (input) {
      var options = clubOptions();
      var name = clean(input && input.flavour).toUpperCase();
      var opt = options[name];
      if (!opt) {
        return 'Unknown flavour "' + name + '". Available: ' + Object.keys(options).join(', ') + '.';
      }
      var button = opt.form.querySelector('button[type="submit"]');
      if (!button || button.disabled) {
        return name + ' cannot be added right now (not available), so it was not added to gfBar Klub.';
      }
      var idInput = opt.form.querySelector('input[name="id"]');
      var variantId = idInput && idInput.value;
      var planId = opt.plan.value;

      var before = 0;
      try { before = await clubQty(variantId, planId); } catch (e) { before = 0; }

      select(opt);
      if (typeof opt.form.requestSubmit === 'function') opt.form.requestSubmit(button);
      else button.click();

      var after = await waitForMore(variantId, planId, before);
      if (after === null) {
        return 'The request to add ' + name + ' as gfBar Klub was sent but could not be confirmed. ' +
          'Check the cart with get_cart before trying again, so it is not added twice.';
      }
      var option = opt.plan.closest('.gf-buytype__opt');
      var terms = clean(option && option.textContent);
      return 'Added 1 carton of ' + name + ' to the cart as gfBar Klub (' + after +
        ' in the cart on this plan now). Terms shown on the page: ' + terms +
        '. The visitor still needs to go to checkout to pay.';
    }
  };

  try {
    var registered = mc.registerTool(tool);
    if (registered && typeof registered.catch === 'function') registered.catch(function () {});
  } catch (e) {
    /* An older or newer WebMCP shape: leave the page as it is. */
  }
})();
